import {
  createThemeSwiper,
  destroyThemeSwiper,
  bindThemeSwiperControls,
  bindShopifySectionSwiper,
} from '@theme/swiper';

class SlideshowOverlap extends HTMLElement {
  connectedCallback() {
    this.handleFocusIn = this.handleFocusIn.bind(this);
    this.handleFocusOut = this.handleFocusOut.bind(this);

    this.addEventListener('focusin', this.handleFocusIn);
    this.addEventListener('focusout', this.handleFocusOut);

    this.cleanupSwiper = bindShopifySectionSwiper(this, () => this.mountSwiper());
  }

  disconnectedCallback() {
    this.removeEventListener('focusin', this.handleFocusIn);
    this.removeEventListener('focusout', this.handleFocusOut);

    this.cleanupSwiper?.();
    this.cleanupSwiper = undefined;
    this.swiper = undefined;
  }

  mountSwiper() {
    const carousel = this.querySelector('[data-overlap-swiper]');

    if (!(carousel instanceof HTMLElement)) return undefined;

    destroyThemeSwiper(this.swiper);

    const swiper = createThemeSwiper(carousel, {
      slidesPerView: 1,
      loop: false,
      allowTouchMove: true,
      watchOverflow: true,
      keyboard: {
        enabled: false,
        onlyInViewport: true,
      },
    });

    const statusElement = this.querySelector('[data-overlap-status]');

    bindThemeSwiperControls(swiper, {
      previousButton: this.querySelector('[data-overlap-previous]'),
      nextButton: this.querySelector('[data-overlap-next]'),
      currentElement: this.querySelector('[data-overlap-current]'),
      totalElement: this.querySelector('[data-overlap-total]'),
      statusElement,
      statusTemplate: statusElement?.dataset.statusTemplate,
    });

    this.swiper = swiper;
    this.syncKeyboardState();

    return swiper;
  }

  handleFocusIn() {
    this.enableKeyboard();
  }

  handleFocusOut(event) {
    const { relatedTarget } = event;

    if (relatedTarget instanceof Node && this.contains(relatedTarget)) return;

    this.disableKeyboard();
  }

  syncKeyboardState() {
    if (this.contains(document.activeElement)) {
      this.enableKeyboard();
    } else {
      this.disableKeyboard();
    }
  }

  enableKeyboard() {
    this.swiper?.keyboard?.enable?.();
  }

  disableKeyboard() {
    this.swiper?.keyboard?.disable?.();
  }
}

if (!customElements.get('slideshow-overlap')) {
  customElements.define('slideshow-overlap', SlideshowOverlap);
}
